import { messages } from "../utils/constants";
import { useAppSelector } from "../hooks/useAppSelector";
import client from "../features/NotificationIcons/client";
import { useNotifications } from "../features/NotificationIcons/useNotifications";
import { getRootAppWindow } from "meta/utils/getRootAppWindow";
export const useEventsWebEvents = (toastMessage) => {
    const { updateNotifications } = useNotifications();
    const { activeTabKey } = useAppSelector((state) => state.root);
    const handleEventReload = async () => {
        try {
            await client.reloadEvents();
            await updateNotifications();
        }
        catch (error) {
            console.error("Reloading events or notifications failed.");
            throw error;
        }
    };
    const closeCurrentTab = () => {
        const topFrame = getRootAppWindow(window);
        topFrame?.frames[activeTabKey].RootCommunicator.closeActiveChild();
        toastMessage(messages.eventCompleted);
    };
    return { handleEventReload, closeCurrentTab };
};
